import {
  GetCurrentCoin,
  GetCurrentCoinV2,
  GiftList,
  Modal,
} from '@src/pageModels/GlobalUserModel';
import { TypeCheck } from '@toptoon/utils';
import { observable, makeObservable, action } from 'mobx';
import _ from 'lodash';
import { remainingDate } from '@src/lib';
class GlobaluserStore {
  @observable modal: Modal | null = null;
  @observable loginCount: string | null = null;
  @observable getCurrentCoin: GetCurrentCoinV2 | null = {
    refreshAt: null,
    goods: {},
    paymentCount: 0,
    hooks: null,
    coin: 0,
    bonusCoin: 0,
  };
  @observable giftList: GiftList | null = null;

  constructor() {
    makeObservable(this);
  }

  @action
  setModal(modal: Modal | null) {
    if (modal) {
      this.modal = modal;
    }
  }

  @action
  setCurrentCoin(getCurrentCoin: GetCurrentCoin | null) {
    if (getCurrentCoin) {
      // this.getCurrentCoin = getCurrentCoin;
      this.getCurrentCoin = this.convertCurrentCoinV2(getCurrentCoin);
    }
  }

  @action
  setGiftList(giftList: GiftList | null) {
    if (giftList) {
      this.giftList = giftList;
    }
  }

  private convertCurrentCoinV2(
    data: GetCurrentCoin | null,
  ): GetCurrentCoinV2 | null {
    if (data === null) return null;

    const { coin, bonusCoin } = CoinParser(data.coins);
    const refreshAt = data.refreshAt && remainingDate(data.refreshAt);

    const v2: GetCurrentCoinV2 = {
      refreshAt: refreshAt,
      goods: data.goods,
      paymentCount: data.paymentCount,
      hooks: data.hooks,
      coin,
      bonusCoin,
    };

    return v2;
  }
}

const CoinParser = (
  coins: any[],
): {
  coin: number;
  bonusCoin: number;
} => {
  const coin = _.sum(
    _.map(
      _.filter(coins, v => v.type < 6),
      'coin',
    ),
  );
  const bonusCoin = _.sum(
    _.map(
      _.filter(coins, v => v.type >= 6),
      'coin',
    ),
  );

  return {
    coin,
    bonusCoin,
  };
};

export default new GlobaluserStore();
